/**
 * A place to review deployments and other system events. Nothing writes to
 * this yet — it is a scaffold, ready for real entries later.
 */
export function SystemStatus() {
  return (
    <>
      <h2>System status</h2>
      <p className="muted">
        A log of deployments and other system events, for when something needs checking.
      </p>
      <p className="empty">No entries yet.</p>
    </>
  );
}
